import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RouterConstant } from "../../routers/index";
import Button from "../../components/button";
import ChatHeader from "../../components/chat-header";
import { ExerciseService } from "../../services/display-exercise/display-exercise.service";
import { AudioService } from "../../services/text-to-audio/texttoaudio.service";
import { useLayoutContext } from "../../layouts/general-layout";
import {
  Loader, doubleVIvon, orangeVIcon
} from "../../assets/images/index";
import "./display-exercise.scss";
import  MathExpressionNew   from '../../components/common/mathjax'; // Adjust the import path as needed
import { ChatService } from "../../services/chat/chat.services";
import { showErrorToast } from "../../components/Toaster/index";
import { useQuestionsStore } from "../../utils/questionStore";
import { useExerciseStore } from "../../utils/exerciseStore";
import SolutionStatusPopup from "../../components/solution-status-popup";
import { Tooltip } from '@mui/material';

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const { ROUTERS_PATH } = RouterConstant;
  const { t } = useLayoutContext();
  const [loading, setLoading] = useState<boolean>(true);
  const [exercise, setExercise] = useState<any>(null);
  const [message, setMessage] = useState<string | null>(null);
  const selectedExerciseId = useExerciseStore((s) => s.selectedExerciseId);
  const [rawImage, setRawImage] = useState<string | null>(null);
  const [showSolutionStatusPopup, setShowSolutionStatusPopup] = useState(false);
  /* const [extractedQuestions, setExtractedQuestions] = useState<string[] | null>(null); */
  const extractedQuestions = useQuestionsStore((s) => s.extractedQuestions);
  const setExtractedQuestions = useQuestionsStore((s) => s.setExtractedQuestions);
  const clearExtractedQuestions = useQuestionsStore((s) => s.clearExtractedQuestions);
  
  const [isExtracting, setIsExtracting] = useState(false);
  const from = location.state?.from;
  const imageFromChat = location.state?.payload?.image;
  const exerciseId = location.state?.exerciseId;

  const exerciseData = location.state?.exerciseData;
  const exerciseServiceInstance = new ExerciseService();
  const audioServiceInstance = new AudioService();
  const chatService = new ChatService();
  const setSelectedExerciseId = useExerciseStore((s) => s.setSelectedExerciseId);
  const setSelectedExerciseName = useExerciseStore((s) => s.setSelectedExerciseName);

  const { searchParams } = useExerciseStore.getState();

  const handleBackClick = () => {
    if (location.state?.returnToExerciseList) {
      navigate(ROUTERS_PATH.EXERCISE_PRACTICE, {
        state: {
          ...location.state,
          showExerciseListDirectly: true,
          fromDisplayExercise: false,
          selectedExercise: undefined
        }
      });
    } else if (from === "notifications") {
      navigate(ROUTERS_PATH.NOTIFICATIONS);
    } else if (from === "exercises-homework") {
      navigate(ROUTERS_PATH.EXERCISES_HOMEWORK);
    } else if (from === "searchExercise") {
      navigate(ROUTERS_PATH.SEARCHEXRCISE);
    } else if (from === "searchByBook") {
      navigate(ROUTERS_PATH.SEARCHBYBOOK);
    } else {
      navigate(ROUTERS_PATH.USER_MAIN_DASHBOARD);
    }
  };

  const handleSelectClick = () => {
    if (!exercise?.id) {
      showErrorToast(t("exerciseNotFound"));
      return;
    }
    setSelectedExerciseId(exercise.id);
    navigate(ROUTERS_PATH.EXERCISE_PRACTICE, {
      state: { 
        ...location.state,
        fromDisplayExercise: true,
        selectedExercise: exercise 
      },
    });
  };

  const handleDisplayDifferentExercise = async () => {
    audioServiceInstance.stopAudio();
  
    let { level, topicId, difficultyId, offset, totalExercise } = searchParams || {};
  
    if (!level || !topicId || !difficultyId) {
      if (exercise) {
        level = exercise.lu_level?.id || level;
        topicId = exercise.lu_topic?.id || topicId;
        difficultyId = exercise.lu_difficulty?.id || difficultyId;
      }
    }
    if (!totalExercise || totalExercise < 1) {
      totalExercise = 1;
    }
    if (!totalExercise || totalExercise < 1)   if (offset == null) {
      offset = 1;
    }

    if (!level || !topicId || !difficultyId) {
      setMessage(t('exerciseNotFound'));
      return;
    }
  
    const newOffset = (offset + 1) % totalExercise;
    useExerciseStore.getState().updateOffset(newOffset);
  
    await fetchExercise(newOffset, level, topicId, difficultyId);
  };

  const handleSpecificQuestionClick = (question: string) => {
      navigate(ROUTERS_PATH.CHAT, {
          state: {
            api: "TalkWithChat_by_image_specific_question",
            payload: { image: rawImage, question: `ענה על ${question}` },
            from: "display-exercise",
          },
        });
  };

  const handleAnswerAllClick = () => {
      navigate(ROUTERS_PATH.CHAT, {
          state: {
            api: "TalkWithChat_by_image",
            payload: { image: rawImage },
            from: "display-exercise",
          },
        });
  };

  const processExerciseData = (data: any) => {
    setLoading(false);
    if (data.exercise_content) {
      setSelectedExerciseName(data.filename);
      setExercise({
        id: data.exercise_id || data.id,
        exercise_content: data.exercise_content,
        filename: data.filename,
        lu_level: data.lu_level,
        lu_topic: data.lu_topic,
        lu_difficulty: data.lu_difficulty,
        is_solution_approved: data.is_solution_approved
      });
      try {        
      } catch (audioError) {
        console.error("Error playing 'goodexercisechoise' audio:", audioError);
      }
    } else if (data.capture_image_b64) {
      setRawImage(data.capture_image_b64);
      setExercise(null);
      // Clear previous extracted questions for new image
      setExtractedQuestions(data.questions && data.questions.length > 0 ? data.questions : null);
    }
  };

  const fetchExercise = async (currentOffset: number, level: number, topicId: number, difficultyId: number) => {
    setLoading(true);
    try {
      const response = await exerciseServiceInstance.fetchExercise(level, topicId, difficultyId, currentOffset);

      if (response?.exercises?.length > 0) {
        setSelectedExerciseName(response.exercises[0].filename);
        setExercise({ ...response.exercises[0] });
        useExerciseStore.getState().setTotalExercise(response.total); // Use the defined method
        setMessage(null); // clear message on success
        // Audio selection disabled on display exercise page
        
      } else {
        setExercise(null);
        setMessage(t('exerciseNotFound'));
      }
    } catch (error) {
      console.error("Error fetching exercise:", error);
      setMessage(t('exerciseNotFound'));
    } finally {
      setLoading(false);
    }
  };

  const fetchExerciseById = async (exerciseId: number) => {
    setLoading(true);
    try {
      if (exerciseId) {
        const response = await chatService.GETEXERCISECONTENT(exerciseId);
        if (response?.exercise_content) {
          setSelectedExerciseName(response.filename);
          processExerciseData({
            exercise_id: exerciseId ? exerciseId : response.exercise_id || selectedExerciseId.toString(),
            exercise_content: response.exercise_content,
            lu_level: response.lu_level,
            lu_topic: response.lu_topic,
            lu_difficulty: response.lu_difficulty,
            is_solution_approved: response.is_solution_approved
          });
        } else {
          setExercise(null);
          setMessage(t('exerciseNotFound'));
        }
      } else {
        setExercise(null);
        setMessage(t('exerciseNotFound'));
      }
    } catch (error) {
      console.error("Error fetching exercise:", error);
      setMessage(t('exerciseNotFound'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      audioServiceInstance.stopAudio();
    };
  }, []);

  useEffect(() => {
    // Reset exercise state when navigating back to this page
    setExercise(null);
    useQuestionsStore.getState().clearSteps();      
    
    const { level, topicId, difficultyId, offset } = searchParams;

    if (from === "chat" && imageFromChat) {
      setRawImage(imageFromChat);
    } if (exerciseData) {
      processExerciseData(exerciseData);
    } else if (exerciseId) {
      setSelectedExerciseId(exerciseId);
      fetchExerciseById(exerciseId);
    } else if (from === "searchExercise" && level && topicId && difficultyId) {
      fetchExercise(offset, level, topicId, difficultyId);
    } else if (selectedExerciseId) {
      fetchExerciseById(selectedExerciseId);
    } else if (level && topicId && difficultyId) {
      fetchExercise(offset, level, topicId, difficultyId);
    } else {
      setLoading(false);
    }
  }, [location.state]);

  return (
    <div
        className={`display-exercise-page ${
          showSolutionStatusPopup ? "modal-overlay" : ""
        }`}
      >
      <ChatHeader
        chatHeading={t("displayingSelectedExercise")}
        onBackClick={handleBackClick}
      />
      <div className="display-exercise-body">
        <div className="display-exercise-list">
          {/* Exercise Info Header */}
          {!rawImage && (
            <div className="display-exercise-list-inner pills-container">
            {loading && (
              <div className="display-exercise-list-header">
                <div className="loaderBlock">
                  <img src={Loader} alt="Loader" />
                </div>
              </div>
            )}
            <div className="display-exercise-list-items">
              {exercise && (
                <div className="exercise-chip">
                  {exercise.lu_level && (
                    <Tooltip title={exercise.lu_level.name} enterTouchDelay={0} arrow>
                      <span>{exercise.lu_level.name}</span>
                    </Tooltip>
                  )}
                  {exercise.lu_topic && (
                    <Tooltip title={exercise.lu_topic.name} enterTouchDelay={0} arrow>
                      <span>{exercise.lu_topic.name}</span>
                    </Tooltip>
                  )}
                  {exercise.lu_difficulty && (
                    <Tooltip title={exercise.lu_difficulty.name} enterTouchDelay={0} arrow>
                      <span>{exercise.lu_difficulty.name}</span>
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          </div>
          )}

          {/* Exercise Content */}
          <div className="display-exercise-list-inner">
            <div className="display-exercise-list-header sub-header">
              <h6 className="display-exercise-list-title">{t("exercise")}</h6>
              {!loading && (exercise || rawImage) && (
                <div className="approval-status-icon" onClick={() => setShowSolutionStatusPopup(true)}>
                  {rawImage ? (
                    <> 
                      <span className="status-text">{t("unverifiedAnswer")}</span>
                      <img src={orangeVIcon} alt="Pending Approval" className="status-icon" />
                    </>
                  ) : exercise?.is_solution_approved ? (
                    <>
                      <span className="status-text">{t("verifiedAnswer")}</span>
                      <img src={doubleVIvon} alt="Approved Solution" className="status-icon" />
                    </>
                  ) : (
                    <>
                      <span className="status-text">{t("unverifiedAnswer")}</span>
                      <img src={orangeVIcon} alt="Pending Approval" className="status-icon" />
                    </>
                  )}
                </div>
              )}
              {loading && (
                <div className="loaderBlock">
                  <img src={Loader} alt="Loader" />
                </div>
              )}
            </div>
            <div className="display-exercise-list-items">
              {!loading && message && (
                <div className="no-exercise-message">
                  <p>{message}</p>
                </div>
              )}
              {!loading && rawImage && (
                <div className="captured-image-preview">
                  <img src={rawImage} alt="Uploaded capture" className="captured-image" />
                </div>
              )}
              {exercise && !message && !rawImage && (
                <div key={exercise.id}>
                  <MathExpressionNew content={exercise.exercise_content} variant="exercise" />
                </div>
              )}
            </div>
          </div>
      
          {/* Extracted Questions Section - Displayed inline */}
          {!exercise && rawImage && extractedQuestions && !isExtracting && (
              <div className="questions-inline-container">
                  <h3>{t("whichSectionHelp")}</h3>
                  <div className="question-list">
                      {extractedQuestions.map((q, i) => (
                          <Button 
                            key={i} 
                            text={`${t("solve_this_question")} ${q}`}
                            onClick={() => handleSpecificQuestionClick(q)}                          
                            className="question-btn"
                          />
                      ))} 
                  </div>
              </div>
          )}          
        </div>
 

        {/* Buttons */}
        {exercise && (          
          <div className="display-exercise-button">
            <Button
              text={t("showAnotherExercise")}
              className="button-border"
              color="blue"
              onClick={handleDisplayDifferentExercise}
              loader={loading}
              disabled={loading || from === "searchByBook" || from === "exercises-homework"}
            />
            <Button
              text={t("selectExercise")}
              color="blue"
              onClick={handleSelectClick}
              disabled={loading}
            />
          </div>
        )}

      </div>
      {showSolutionStatusPopup && (
        <SolutionStatusPopup onClose={() => setShowSolutionStatusPopup(false)} />
      )}

        {rawImage && (
          <div className="display-exercise-button">
            <Button
              text={t("exemption")}
              color="blue"
              onClick={handleAnswerAllClick}
              disabled={loading}
            />
          </div>
        )}      

    </div>
  );
}
